<template>
    <div>
        <action-bar>
        </action-bar>
        <main class="content">
            <div>
                <h1>Project erstellen</h1>
                <div class="form-group">
                    <label for="input_name">Name</label>
                    <input type="text" class="form-control" v-model="name" id="input_name">
                </div>
                <button class="btn btn-primary" @click="save">Erstellen</button>
            </div>
        </main>
    </div>
</template>
<script>
export default {
  data() {
    return {
      name: ""
    };
  },
  methods: {
    save() {
      let form = new FormData();
      form.append("create_project[name]", this.name);
      form.set("create_project[submit]", null);
      axios
        .post("/api/" + store.state.language + "/project/create", form)
        .then(({ data }) => {
          store.commit("addProject", data.result);
          this.$router.push({ name: "project-list" });
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/project/Create.vue